import { Printer, ArrowLeft } from "lucide-react";
import { SERVICES, ADD_ONS, PHONE_DISPLAY, ADDRESS } from "@/data/spa";
import { useLang, LANGS } from "@/i18n/LanguageContext";

export default function PrintMenu() {
  const { t, lang, setLang } = useLang();
  const m = t.menu;

  return (
    <div className="min-h-screen bg-[#2a2620] py-8 px-4 print:bg-white print:p-0">
      <div className="max-w-3xl mx-auto mb-6 flex flex-wrap items-center justify-between gap-4 print:hidden">
        <a href="/" data-testid="menu-back-link" className="flex items-center gap-2 text-[#c5a059] hover:text-[#dcc286] text-xs tracking-[0.2em] uppercase transition-colors duration-300">
          <ArrowLeft size={14} /> {m.back}
        </a>
        <div className="flex items-center gap-3">
          <div className="flex gap-1">
            {LANGS.map((l) => (
              <button
                key={l.code}
                data-testid={`menu-lang-${l.code}`}
                onClick={() => setLang(l.code)}
                className={`px-3 py-1.5 text-[11px] tracking-[0.15em] uppercase border transition-colors duration-300 ${
                  lang === l.code ? "border-[#c5a059] text-[#c5a059]" : "border-white/20 text-[#b5ab98] hover:text-white"
                }`}
              >
                {l.label}
              </button>
            ))}
          </div>
          <button
            onClick={() => window.print()}
            data-testid="menu-print-button"
            className="flex items-center gap-2 bg-[#c5a059] hover:bg-[#dcc286] text-[#050706] px-6 py-2.5 text-xs tracking-[0.2em] uppercase font-medium transition-colors duration-300"
          >
            <Printer size={14} /> {m.print}
          </button>
        </div>
      </div>

      <div data-testid="print-menu-sheet" className="max-w-3xl mx-auto bg-[#faf6ec] text-[#2a2620] px-10 py-12 sm:px-14 sm:py-16 shadow-2xl print:shadow-none print:max-w-none">
        <div className="text-center border-b-2 border-[#b08d43] pb-8">
          <div className="flex items-center justify-center gap-3 text-[#b08d43]">
            <span className="h-px w-10 bg-[#b08d43]" />
            <span className="font-serif-display text-2xl">靜</span>
            <span className="h-px w-10 bg-[#b08d43]" />
          </div>
          <h1 className="mt-4 font-serif-display font-semibold text-5xl tracking-tight">
            Elite <span className="italic text-[#b08d43]">Spa</span>
          </h1>
          <p className="mt-2 text-[11px] tracking-[0.35em] uppercase text-[#7a7160]">{m.subtitle}</p>
          <h2 className="mt-6 font-serif-display text-2xl italic text-[#b08d43]">{m.title}</h2>
        </div>

        <div className="mt-10 space-y-9">
          {SERVICES.map((s) => {
            const tr = t.services.items[s.id];
            return (
              <div key={s.id} className="break-inside-avoid">
                <div className="flex items-baseline gap-3">
                  <span className="font-serif-display italic text-[#b08d43]">{s.number}</span>
                  <h3 className="font-serif-display text-2xl font-medium">{tr.name}</h3>
                  <span className="text-[10px] tracking-[0.25em] uppercase text-[#7a7160]">{tr.tag}</span>
                </div>
                <p className="mt-1.5 text-sm text-[#5d5546] font-light leading-relaxed max-w-2xl">{tr.description}</p>
                <div className="mt-3 grid grid-cols-2 sm:grid-cols-3 gap-x-10">
                  {s.pricing.map((p) => (
                    <div key={p.duration} className="flex items-baseline gap-2 py-1">
                      <span className="text-sm text-[#5d5546]">{p.duration.split(" ")[0]} {t.services.minutes}</span>
                      <span className="flex-1 border-b border-dotted border-[#b08d43]/50 -translate-y-1" />
                      <span className="font-serif-display text-lg text-[#b08d43] font-medium">{p.price}</span>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}

          <div className="break-inside-avoid border-t-2 border-[#b08d43] pt-7">
            <div className="flex items-baseline gap-3">
              <h3 className="font-serif-display text-2xl font-medium">{m.addonsTitle}</h3>
              <span className="text-[10px] tracking-[0.25em] uppercase text-[#7a7160]">{m.addonsNote}</span>
            </div>
            <div className="mt-3 grid grid-cols-2 gap-x-10">
              {ADD_ONS.map((a, i) => (
                <div key={a.name} className="flex items-baseline gap-2 py-1">
                  <span className="text-sm text-[#5d5546]">{t.services.addons.items[i]}</span>
                  <span className="flex-1 border-b border-dotted border-[#b08d43]/50 -translate-y-1" />
                  <span className="font-serif-display text-lg text-[#b08d43] font-medium">{a.price}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 border-t-2 border-[#b08d43] pt-6 text-center">
          <p className="text-[11px] tracking-[0.25em] uppercase text-[#7a7160]">
            {m.giftNote} · {m.tipsNote}
          </p>
          <p className="mt-4 font-serif-display text-xl">
            {PHONE_DISPLAY} <span className="text-[#b08d43] mx-2">·</span> {ADDRESS}
          </p>
          <p className="mt-1 text-[11px] tracking-[0.25em] uppercase text-[#7a7160]">{t.contact.hoursValue}</p>
        </div>
      </div>
    </div>
  );
}
